import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M9 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2M1.25 10.5c0 .414.336.75.75.75h16.75a3 3 0 0 0 0-6c-1.257 0-2.518.815-2.953 1.99a.75.75 0 1 0 1.406.52c.2-.54.867-1.01 1.547-1.01a1.5 1.5 0 0 1 0 3H2a.75.75 0 0 0-.75.75M3.25 14a.75.75 0 0 1 .75-.75h9a3 3 0 0 1 0 6c-1.257 0-2.518-.815-2.953-1.99a.75.75 0 0 1 1.406-.52c.2.54.867 1.01 1.547 1.01a1.5 1.5 0 1 0 0-3H4a.75.75 0 0 1-.75-.75M21 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0M4 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
  </>
);

const Weather19 = Icon('weather-19', svgContents);

export default Weather19;
